import React from 'react';
import dom from 'react-dom/client';
import {config} from "../index";
import {WireframeEditorProps} from "../editor/wireframe-editor";

export interface NotificationProps {
	heading: string,
	body: React.ReactElement,
	style: 'info' | 'warning' | 'error'
}

export function Popup(body: { children: React.ReactNode, id?: string }) {
	const dialog = (document.querySelector('#modals')
		?? document.body.appendChild(Object.assign(document.createElement('section'), {
			id: 'modals'
		})))
		.appendChild(Object.assign(document.createElement('dialog'), {
			id: body.id ?? ''
		}));

	const render = dom.createRoot(dialog);
	render.render(body.children);

	dialog.addEventListener('close', () => {
		render.unmount();
		dialog.remove();
	});

	dialog.showModal();

	return dialog;
}


export function Notification(props: NotificationProps) {
	const root = (document.querySelector('#notifications')
		?? document.body.appendChild(Object.assign(document.createElement('section'), {id: 'notifications'})))
		.appendChild(document.createElement('dialog'));

	root.classList.add('notification');
	root.popover = 'manual';
	root.setAttribute('style', props.style ?? 'info');

	const render = dom.createRoot(root);

	const close = () => {
		clearTimeout(autoClose);
		root.remove();
		render.unmount();
	};
	const autoClose = setTimeout(() => close(), 10_000);

	render.render(<>
		<button data-icon="⨯" className='symbolic' onClick={() => close()} />

		<div><b>{props.heading}</b></div>
		<div>{props.body}</div>
	</>);

	root.showPopover();
}